"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgreementService = void 0;
class AgreementService {
    httpRequest;
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Chathost Agreement List
     * @returns AgreementResponseList Successful Response
     * @throws ApiError
     */
    chathostChathostAgreementList() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/chathost/agreement/list',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Chathost Agreement Get
     * @param id
     * @returns AgreementResponse Successful Response
     * @throws ApiError
     */
    chathostChathostAgreementGet(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/chathost/agreement/promotion',
            query: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Chathost Agreement Post
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    chathostChathostAgreementPost(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/chathost/agreement/promotion',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Chathost Promotion Agreement Available Get
     * @returns AgreementAvailableResponse Successful Response
     * @throws ApiError
     */
    chathostChathostPromotionAgreementAvailableGet() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/chathost/agreement/promotion/available',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Chathost Consent Status
     * @returns ConsentResponse Successful Response
     * @throws ApiError
     */
    chathostChathostConsentStatus() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/chathost/agreement/consent',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Chathost Consent
     * @param individualId
     * @param formData
     * @returns any Successful Response
     * @throws ApiError
     */
    chathostChathostConsent(individualId, formData) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/chathost/agreement/consent/{individual_id}',
            path: {
                'individual_id': individualId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Chathost Consent Download
     * @param requestBody
     * @returns FileDownloadDetails Successful Response
     * @throws ApiError
     */
    chathostChathostConsentDownload(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/chathost/agreement/consent/download/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                422: `Validation Error`,
            },
        });
    }
}
exports.AgreementService = AgreementService;
